var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, forwardRef, useEffect } from "react";
import classnames from "classnames";
import { Modal, Tabs, ActivityIndicator, Icon } from "../index";
import "./style/index.less";
const stepMap = new Map([
    [-1, "省"],
    [0, "市"],
    [1, "区"],
    [2, "街道"],
    [3, "社区"],
    [4, "网格"],
]);
// Todo 回填
// 省市区街道
const AreaPicker = forwardRef(({ visible = false, onModalClose, onChooseHandler, limit = 5, organizationListChild, organizationGetRoot, }, _ref) => {
    const [tabs, setTabs] = useState([]);
    const [panes, setPanes] = useState([]);
    const [allPanes, setAllPanes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState(-1);
    const formatTitle = (val, len) => {
        if (val.length > len) {
            return `${val.slice(0, len)}...`;
        }
        return val;
    };
    const _organizationListChild = (params) => __awaiter(this, void 0, void 0, function* () {
        try {
            setLoading(true);
            const { data: field } = yield organizationListChild(params);
            const _field = field.map((item) => (Object.assign({}, item, { title: item.orgName })));
            const _tabs = tabs.slice();
            const _allPanes = allPanes.slice();
            if (step > -1) {
                const title = formatTitle(panes.find((item) => item.checked).title, 4);
                _tabs.splice(step, 1, { title });
            }
            _tabs.push({ title: `选择${stepMap.get(step)}` });
            _allPanes.push(_field);
            setStep(step + 1);
            setTabs(_tabs);
            setAllPanes(_allPanes);
            setPanes(_field);
        }
        catch (error) {
        }
        finally {
            setLoading(false);
        }
    });
    const initData = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const { data: { id }, } = yield organizationGetRoot({});
            _organizationListChild({ id, "orgType[]": 90180001 });
        }
        catch (error) { }
    });
    useEffect(() => {
        initData();
    }, []);
    const onClose = () => {
        if (onModalClose) {
            onModalClose();
        }
    };
    const choosePlace = (tab) => {
        const _panes = panes.slice();
        _panes.forEach((item) => {
            if (item.orgName === tab.title) {
                item.checked = true;
            }
            else {
                item.checked = false;
            }
        });
        if (!tab.parent || step >= limit) {
            const _tabs = tabs.slice();
            _tabs[_tabs.length - 1].title = formatTitle(tab.orgName, 4);
            setTabs(_tabs);
            setPanes(_panes);
            return;
        }
        _organizationListChild({ id: tab.id, "orgType[]": 90180001 });
    };
    const onTabClickHandler = (_tab, index) => {
        const _allPanes = allPanes.slice();
        setStep(index);
        setTabs(tabs.slice(0, index + 1));
        setPanes(_allPanes[index]);
        setAllPanes(_allPanes.slice(0, index + 1 || 1));
    };
    const confirm = () => {
        if (onChooseHandler) {
            onChooseHandler(allPanes);
            onClose();
        }
    };
    const renderContent = (_tab, key) => (<div className={classnames("content")} key={key}>
        <div className={classnames("content-title")}>
          {stepMap.get(step - 1)}
        </div>
        {loading ? (<ActivityIndicator text="Loading..."/>) : (panes &&
        panes.length > 0 &&
        panes.map((item) => (<div key={item.id} className={classnames("content-item", { active: item.checked })} onClick={() => choosePlace(item)}>
              <span>{item.orgName}</span>
              {item.checked && <Icon type="check" size="xs"/>}
            </div>)))}
      </div>);
    return (<span className={classnames("ppx-area-picker")}>
        <Modal popup visible={visible} onClose={onClose} animationType="slide-up" className="ppx-area-modal">
          <div className={classnames("modal-title")}>
            <span className={classnames("tool")} onClick={onClose}>
              取消
            </span>
            <span className={classnames("name")}>
              选择{stepMap.get(step - 1)}
            </span>
            <span className={classnames("tool")} onClick={confirm}>
              确认
            </span>
          </div>
          <Tabs tabs={tabs} renderTabBar={(props) => (<Tabs.DefaultTabBar {...props} activeTab={step}/>)} onTabClick={onTabClickHandler}>
            {renderContent}
          </Tabs>
        </Modal>
      </span>);
});
export default AreaPicker;
